import { fetchInventoryMoveLogsRoutine } from 'modules/inventoryMoveLogs/ducks/actions'

const defaultState = {
  list: [],
  pagination: null,
  isLoading: false
}

const inventoryMoveLogsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case fetchInventoryMoveLogsRoutine.TRIGGER:
      return {
        ...state,
        isLoading: true
      }
    case fetchInventoryMoveLogsRoutine.FAILURE:
      return {
        ...state,
        isLoading: false
      }
    case fetchInventoryMoveLogsRoutine.SUCCESS:
      return {
        ...state,
        list: action.payload.data,
        pagination: {
          itemsCount: action.payload.meta.total,
          totalPages: action.payload.meta.lastPage,
          perPage: action.payload.meta.perPage,
          currentPage: action.payload.meta.currentPage
        },
        isLoading: false
      }
    default:
      return state
  }
}

export default inventoryMoveLogsReducer
